// src/helpers/tokenManager.js
import { getToken } from 'firebase/messaging';
import { messaging } from '../lib/firebase'; // ajusta la ruta si es necesario
import { API_URL } from '../config';
import { authFetch } from '../utils';


const getDeviceId = () => {
  let deviceId = localStorage.getItem('deviceId');
  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem('deviceId', deviceId);
  }
  return deviceId;
};

const sendTokenToServer = async (token) => {
  await authFetch(`${API_URL}push-notifications/store-token`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username: localStorage.getItem('username'), token, deviceId: getDeviceId() }),
  });
};

export const requestAndSendFirebaseToken = async () => {
  const permission = await Notification.requestPermission();
  if (permission !== 'granted') return;

  const token = await getToken(messaging, {
    vapidKey: process.env.REACT_APP_VAPID_KEY,
  });

  await sendTokenToServer(token);
};

